/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Section_Mark_ReviewedInputs */

const en_case_section_mark_reviewed = /** @type {(inputs: Case_Section_Mark_ReviewedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mark as reviewed`)
};

const pt_br2_case_section_mark_reviewed = /** @type {(inputs: Case_Section_Mark_ReviewedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Marcar como revisado`)
};

/**
* | output |
* | --- |
* | "Mark as reviewed" |
*
* @param {Case_Section_Mark_ReviewedInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_section_mark_reviewed = /** @type {((inputs?: Case_Section_Mark_ReviewedInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Section_Mark_ReviewedInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_section_mark_reviewed(inputs)
	return pt_br2_case_section_mark_reviewed(inputs)
});